import gql from 'graphql-tag';

/*
    calculationBinaryFileId
    bitmapBinaryFileId
    vectorBinaryFileId
    distributionBinaryFileId
*/
export const GET_TARGET_SCORING_DEFINITION_QUERY = gql`
  query getTargetScoringDefinition($id: ID) {
    getTargetScoringDefinition(id: $id) {
      distributionBinaryFileId
      targetScoringDefinition {
        id
        version
        name
        visualNumber
        organizationTargetName
        organizationTargetId
      }
      released
      updatedAt
    }
  }
`;

export const GET_PHYSICAL_TARGET_DEFINITION_QUERY = gql`
  query getPhysicalTargetDefinition($id: ID) {
    getPhysicalTargetDefinition(id: $id) {
      accessories {
        type
        variant
        default
      }
      description
      detectionArea {
        x
        y
      }
      detectionSettings {
        algorithm
        autoGainEnabled
        caliberTags
        distanceFrom
        distanceTo
        initialGain
        maximumGain
        minimumGain
        name
      }
      feederSetup {
        material
        partNumber
        partName
        caliberTags
        length
        interval
      }
      guid
      name
      sensors {
        name
        type
        x
        y
      }
      technology
      version
      released
    }
  }
`;

export const GET_TARGET_SCORING_DEFINITION_RELEASE_FILTER_QUERY = gql`
  query getTargetScoringDefinitionReleaseByFilter(
    $id: ID!
    $versionFilter: String
    $limit: Int
  ) {
    getTargetScoringDefinitionReleaseByFilter(
      targetScoringDefinitionId: $id
      versionFilter: $versionFilter
      limit: $limit
    ) {
      id
      version
      versionMajor
      versionMinor
      versionPatch
      versionPrerelease
      versionPrereleaseNumber
      binaryFileUuid
      dateTime
      publicationStatus
    }
  }
`;
export const GET_PHSYSICAL_TARGET_DEFINITION_RELEASE_QUERY = gql`
  query getPhysicalTargetDefinitionReleaseByFilter(
    $physicaltargetDefinitionId: ID!
    $versionFilter: String!
    $limit: Int
  ) {
    getPhysicalTargetDefinitionReleaseByFilter(
      physicaltargetDefinitionId: $physicaltargetDefinitionId
      versionFilter: $versionFilter
      limit: $limit
    ) {
      id
      binaryFileUuid
      version
      versionMajor
      versionMinor
      versionPatch
      versionPrerelease
      versionPrereleaseNumber
      dateTime
    }
  }
`;

export const SEARCH_TARGET_SCORING_DEFINITION_QUERY = gql`
  query searchTargetScoringDefinition($text: String!, $limit: Int) {
    searchTargetScoringDefinition(text: $text, limit: $limit) {
      targetScoringDefinition {
        id
      }
    }
  }
`;

export const ADD_OR_UPDATE_PHYSICAL_TARGET_DEFINITION_MUTATION = gql`
  mutation addOrUpdatePhysicalTargetDefinition(
    $id: ID
    $physicaltargetDefinition: PhysicalTargetDefinitionInput!
  ) {
    addOrUpdatePhysicalTargetDefinition(
      id: $id
      physicaltargetDefinition: $physicaltargetDefinition
    ) {
      guid
    }
  }
`;
export const GENERATE_PHYSICAL_TARGET_DEFINITION_MUTATION = gql`
  mutation generatePhysicalTargetDefinitionRelease(
    $id: ID!
    $increaseVersion: SemVerIncreaseType
  ) {
    generatePhysicalTargetDefinitionRelease(
      id: $id
      increaseVersion: $increaseVersion
    ) {
      id
    }
  }
`;

export const UPLOAD_TARGET_SCORING_DEFINITION_MUTATION = gql`
  mutation uploadTargetScoringDefinition($file: Upload!) {
    uploadTargetScoringDefinition(file: $file) {
      import {
        total
        success
        error
      }
      errorLog
    }
  }
`;

export const UPLOAD_TARGET_SCORING_DEFINITION_RELEASE_GENERATE_MUTATION = gql`
  mutation generateTargetScoringDefinitionRelease(
    $id: ID!
    $increaseVersion: SemVerIncreaseType
  ) {
    generateTargetScoringDefinitionRelease(
      id: $id
      increaseVersion: $increaseVersion
    ) {
      id
    }
  }
`;

export const DELETE_TARGET_SCORING_DEFINITION_RELEASE_MUTATION = gql`
  mutation deleteTargetScoringDefinitionRelease($id: ID!) {
    deleteTargetScoringDefinitionRelease(id: $id)
  }
`;

export const DELETE_PHYSICAL_TARGET_DEFINITION_RELEASE_MUTATION = gql`
  mutation deletePhysicalTargetDefinitionRelease($id: ID!) {
    deletePhysicalTargetDefinitionRelease(id: $id)
  }
`;

export const UPDATE_TARGET_SCORING_DEFINITION_RELEASE_PUBLICATION_STATUS = gql`
  mutation updateTargetScoringDefinitionReleasePublicationStatus(
    $id: ID!
    $publicationStatus: PublicationStatus!
  ) {
    updateTargetScoringDefinitionReleasePublicationStatus(
      id: $id
      publicationStatus: $publicationStatus
    ) {
      id
    }
  }
`;
